export const AUTH_SIGNIN = 'AUTH_SIGNIN'
export const AUTH_SIGNOUT = 'AUTH_SIGNOUT'
